export const STRUCTURE_DROPDOWN_TYPE_REQUEST = 'STRUCTURE_DROPDOWN_TYPE_REQUEST';
export const STRUCTURE_DROPDOWN_TYPE_SUCCESS = 'STRUCTURE_DROPDOWN_TYPE_SUCCESS';
export const STRUCTURE_DROPDOWN_TYPE_FAIL = 'STRUCTURE_DROPDOWN_TYPE_FAIL';

